// Keep Office diagnostics useful without recording request statements or document data.
export const sanitizeOfficeError = (error: unknown) => {
    const details = error && typeof error === 'object' ? (error as Record<string, unknown>) : {};
    const sanitizeText = (value: unknown, fallback = ''): string =>
        typeof value === 'string'
            ? value
                  .replace(/https?:\/\/[^\s]+/gi, '[redacted]')
                  .replace(/[\w.+-]+@[\w.-]+\.[a-z]+/gi, '[redacted]')
                  .replace(/"[^"\r\n]*"|'[^'\r\n]*'|`[^`\r\n]*`/g, '[redacted]')
                  .replace(/<[^>]*>/g, '')
                  .replace(/[\x00-\x1f\x7f]/g, ' ')
                  .slice(0, 500)
            : fallback;
    const debugInfo =
        details.debugInfo && typeof details.debugInfo === 'object'
            ? (details.debugInfo as Record<string, unknown>)
            : {};

    return {
        code: sanitizeText(details.code),
        message: sanitizeText(
            typeof error === 'string' ? error : details.message,
            'Unable to apply classification. Please try again.',
        ),
        // fullStatements, surroundingStatements, innerError and arbitrary fields may contain content.
        debugInfo: {
            code: sanitizeText(debugInfo.code),
            errorLocation: sanitizeText(debugInfo.errorLocation),
        },
    };
};
